import {
  EXERCISE_TYPE,
  LOGGER_AWS_KINESIS_STREAM_NAME,
  VUEX_ROOT_GETTER_NAMES
} from "@tt-app/constants";
import { kinesis } from "@tt-app/utils/logger/kinesis";

import store from "@tt-app/store";
import PackageInfo from "../../../package.json";
import GitInfo from "../../../GitInfo.json";

const exercisesToLog = [
  EXERCISE_TYPE.CHAT,
  EXERCISE_TYPE.DRILL_PRONUNCIATION,
  EXERCISE_TYPE.SINGLE_SENTENCE_READING
];

export const logger = {
  async logEvent(event: any, payload: any) {
    if (!exercisesToLog.includes(payload.exerciseType)) {
      return;
    }

    const appState = store.state;

    const profile = (appState as any).user.profile;
    const authInfo = store.getters[VUEX_ROOT_GETTER_NAMES.AUTH_INFO];

    const windowUrl = window.location.href;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    const baseDimensions = {
      ...event,
      Time: Date.now(),
      TimeUnit: "MILLISECONDS",
      TT4WHash: (GitInfo as any).commitHash,
      TT4WVersion: (PackageInfo as any).version,
      UserAgent: window.navigator.userAgent,
      Source: "TT4W",
      Hyperlink: windowUrl,
      AliasUUID: authInfo.aliasUuid,
      OrgHash: profile.org.hash,
      ScreenDimensions: `${windowWidth}x${windowHeight}`,
      NetworkMode: profile.useOnlyHttp ? "Basic" : "Turbo",
      Accent: profile.audio.accent,
      SpeakingSpeed: profile.audio.speed
    };

    const conditionalDimensions = {
      CourseUUID: payload?.courseUuid,
      ErrorMessage: payload?.error?.message,
      ExerciseType: payload?.exerciseType,
      ExerciseUUID: payload?.exerciseUuid,
      ExerciseLogID: payload?.logId,
      ProblemUUID: payload?.uuid,
      ExternalUrl: payload?.url,
      ConnectionResult: payload?.connectionResult,
      Duration: payload?.duration
    };

    const allDimensions = {
      ...baseDimensions,
      ...conditionalDimensions
    };

    console.log(allDimensions);

    const eventDetailsString = JSON.stringify(allDimensions);

    const params = {
      Data: Buffer.from(eventDetailsString),
      PartitionKey: "tt4wPartition1",
      StreamName: LOGGER_AWS_KINESIS_STREAM_NAME
    };

    const kinesisRequest = kinesis.putRecord(params);

    kinesisRequest.send();
  },

  log(...args: any[]) {
    if (process.env.NODE_ENV === "production") {
      return;
    }

    console.log(...args);
  }
};
